export const CONFIG_DATA = {
	DEFAULT_MIN_SALE_RATE: 1,
	DEFAULT_MAX_SALE_RATE: 100,
	DEFAULT_MIN_EXCHANGE_RATE: 20000,
};
